/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupenablehint2Inputs */

const en_signupenablehint2 = /** @type {(inputs: Signupenablehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests sign up in the app and on the web and answer your questions. Only you see the answers.`)
};

const de_signupenablehint2 = /** @type {(inputs: Signupenablehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste melden sich in der App und im Web an und beantworten deine Fragen. Die Antworten siehst nur du.`)
};

/**
* | output |
* | --- |
* | "Guests sign up in the app and on the web and answer your questions. Only you see the answers." |
*
* @param {Signupenablehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupenablehint2 = /** @type {((inputs?: Signupenablehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupenablehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupenablehint2(inputs)
	return de_signupenablehint2(inputs)
});
export { signupenablehint2 as "signupEnableHint" }